import { Router, ActivatedRoute } from '@angular/router';
import { API_CALL_ERROR } from './../../../../store/action';
import { ApiService } from './../../../../api/api.service';
import { AppInjector } from './../../../../app-injector';
import { takeEvery, put, takeLatest } from 'redux-saga/effects';
import * as _ from 'lodash';
import {
  SCAN_LOCATION_REQUESTED,
  ACCESS_LAST_SCAN_PAGE,
  FETCH_ALL_LOCATIONS_REQUESTED,
  SCAN_RACK_FETCH_LIST_LOCATION_SUCCEEDED,
  SCAN_LOCATION_SUCCEEDED,
  SCAN_RACK_FETCH_LIST_LOCATION_REQUESTED,
  MAP_LATEST_SCAN_TO_LOCATIONS_LIST,
  UPDATE_SCAN_RACK_DESTINATION_FILTER,
  FETCH_NUMBER_OF_PRODUCT_PER_LOCATION_SUCCESSED
} from './list.actions';
import { NotificationService } from '../../../../common/services/notification/notification.service';
import { FETCH_ALL_DESTINATION_REQUESTED } from '../../../destination/destination.action';

function* fetchLocations(action) {
  try {
    const api = AppInjector.get(ApiService);
    let results = yield api.location.get(action.data.pagination, action.data.sort).toPromise();
    yield put({
      type: SCAN_RACK_FETCH_LIST_LOCATION_SUCCEEDED,
      data: results.items,
      pagination: results.pagination
    });
  } catch (e) {
    yield put({ type: API_CALL_ERROR, error: e });
  }
}

function* watchFetchLocationRequested() {
  yield takeEvery(SCAN_RACK_FETCH_LIST_LOCATION_REQUESTED, fetchLocations);
}

function* fetchDestinations(action) {
  yield put({ type: FETCH_ALL_DESTINATION_REQUESTED, com: 'SCAN_RACK_COMPONENT' });
}

function* fetchNumberOfProduct(action) {
  try {
    let result = yield AppInjector.get(ApiService)
      .analytic.getNumberOfProductPerLocation({ location_ids: _.map(action.data, item => item.getId()) })
      .toPromise();
    yield put({
      type: FETCH_NUMBER_OF_PRODUCT_PER_LOCATION_SUCCESSED,
      data: result
    });
  } catch (e) {
    yield put({ type: API_CALL_ERROR, error: e });
  }
}

function* watchFetchLocationSuccessed() {
  yield takeEvery(SCAN_RACK_FETCH_LIST_LOCATION_SUCCEEDED, fetchDestinations);
  yield takeEvery(SCAN_RACK_FETCH_LIST_LOCATION_SUCCEEDED, fetchNumberOfProduct);
}

function* scanLocation(action) {
  const api = AppInjector.get(ApiService);
  try {
    let result = yield api.track.create(action.data).toPromise();
    if (result) {
      AppInjector.get(Router).navigate([`/inventory/scan-rack/tracks/${result.getId()}/locations/${result.getLocationId()}`]);
      yield put({ type: SCAN_LOCATION_SUCCEEDED, data: result, latestScan: action.data.latestScan });
    }
  } catch (e) {
    yield put({ type: API_CALL_ERROR, error: e });
  }
}

function* watchScanLocationRequest() {
  yield takeEvery(SCAN_LOCATION_REQUESTED, scanLocation);
}

function* accessLastScanPage(action) {
  const api = AppInjector.get(ApiService);
  try {
    let result = yield api.track.getLastScan(action.data.getId()).toPromise();
    if (result) {
      AppInjector.get(Router).navigate([`/inventory/scan-rack/tracks/${result.getId()}/locations/${action.data.getId()}`]);
    }
  } catch (e) {
    yield put({ type: API_CALL_ERROR, error: e });
  }
}

function* watchAccessLastScanPageRequested() {
  yield takeEvery(ACCESS_LAST_SCAN_PAGE, accessLastScanPage);
}

function* fetchAllLatestScan(action) {
  const api = AppInjector.get(ApiService);
  try {
    let results = yield api.track.getAllLatestScan().toPromise();
    yield put({ type: MAP_LATEST_SCAN_TO_LOCATIONS_LIST, data: results });
  } catch (e) {
    yield put({ type: API_CALL_ERROR, error: e });
  }
}

function* watchFetchScanListRackSuccess() {
  yield takeEvery(SCAN_RACK_FETCH_LIST_LOCATION_SUCCEEDED, fetchAllLatestScan);
}

function updateDestinationFilterr(action) {
  let activeRouter = AppInjector.get(ActivatedRoute);
  let router = AppInjector.get(Router);
  let params = activeRouter.snapshot.params;
  let queryParams = _.assign({}, activeRouter.snapshot.queryParams, { page: 1 });
  let constraints = {};
  if (!_.isUndefined(queryParams.constraints)) {
    constraints = _.assign(constraints, JSON.parse(queryParams.constraints));
  }
  if (action.field === 'destination') {
    if (!_.isUndefined(action.data)) {
      constraints = _.assign(constraints, { destination_id: action.data.getId() });
    } else {
      delete constraints['destination_id'];
    }
  }
  queryParams = _.assign(queryParams, { constraints: JSON.stringify(constraints) });
  router.navigate(['inventory', 'scan-rack'], { queryParams: queryParams });
}

function* watchUpdateDestinationFilter() {
  yield takeLatest(UPDATE_SCAN_RACK_DESTINATION_FILTER, updateDestinationFilterr);
}

export default [
  watchFetchLocationRequested,
  watchFetchLocationSuccessed,
  watchScanLocationRequest,
  watchAccessLastScanPageRequested,
  watchFetchScanListRackSuccess,
  watchUpdateDestinationFilter
];
